import { useGetAllSystemColorsSuspense } from "@/orval/gen"

/// <summary>
/// Hook to get all system colors with a stale time of 20 minutes.
/// </summary>
export function useSystemColors() {
  return useGetAllSystemColorsSuspense({ query: { staleTime: 20 * 60 * 1000 } })
}
